/**
 * Единая палитра цветов каналов для piano roll и чипов-переключателей.
 * Раньше жила локально в `PianoRoll.tsx`; вынесена сюда, чтобы кружок чипа
 * в аккордионе «Каналы» и ноты на таймлайне имели гарантированно одинаковый
 * цвет. Цвет зависит ТОЛЬКО от номера канала и не меняется при включении/
 * выключении других каналов (см. `channelColor`).
 */

export const DRUM_COLOR = "#8D6E63";

export const MELODY_COLORS: ReadonlyArray<string> = [
  "#E63946",
  "#F4A261",
  "#E9C46A",
  "#D05A38",
  "#2A9D8F",
  "#88C057",
  "#1F8A8C",
  "#80CED7",
  "#457B9D",
  DRUM_COLOR,
  "#1D3557",
  "#00B4D8",
  "#3A5A8F",
  "#9B5DE5",
  "#D81B60",
  "#A084E8",
];

/**
 * Цвет канала: канал 9 (ударные) — всегда `DRUM_COLOR`, остальные — по
 * палитре `MELODY_COLORS[channel % len]`. Палитра индексируется НОМЕРОМ
 * канала, а не порядком видимости, поэтому включение/выключение соседних
 * каналов не сдвигает цвета.
 */
export const channelColor = (channel: number): string =>
  channel === 9 ? DRUM_COLOR : MELODY_COLORS[channel % MELODY_COLORS.length]!;
